import React from 'react';
import { renderRoutes } from 'react-router-config';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Header from 'components/Header';
import { IMAGE_PATHS } from 'libs/constants';
import './HeaderLayout.scss';

export default function HeaderLayout(props) {
  const {
    route, headerImagePaths, headerProps, layoutClassName
  } = props;

  return (
    <div className={`Layout--Header ${layoutClassName}`}>
      <Header
        showPopover
        imagePaths={headerImagePaths || IMAGE_PATHS.defaultHeaderLayout}
        signOutLabelText={<FormattedMessage id="views.headerLayout.header.signOut.text" />}
        contactUsLabelText={<FormattedMessage id="views.headerLayout.header.contactUs.text" />}
        {...headerProps}
      />
      <div className="Layout--Header__Content">
        { renderRoutes(route.routes, { ...props }) }
      </div>
    </div>
  );
}

HeaderLayout.propTypes = {
  route: PropTypes.object.isRequired,
  layoutClassName: PropTypes.string,
  headerProps: PropTypes.object,
  headerImagePaths: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.bool
  ]),
};

HeaderLayout.defaultProps = {
  headerImagePaths: false,
  headerProps: {},
  layoutClassName: ''
};



// WEBPACK FOOTER //
// ./src/views/Layout/HeaderLayout/HeaderLayout.jsx